import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BasketService } from '../basket.service';
import { Product, ProductService } from '../product.service';

@Component({
  selector: 'app-search-display',
  templateUrl: './search-display.component.html',
  styleUrls: ['./search-display.component.css']
})
export class SearchDisplayComponent implements OnInit {
  @Input() key: string = '';
  @Input() qty: number = 1;
  @Output() barcode = new EventEmitter<string>();
  dataSource: MatTableDataSource<Product> | undefined
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  constructor(private productService: ProductService, private basketService: BasketService) {
  }

  displayedColumnsSearch: string[] = ['no', 'name', 'unit', 'front_store_price', 'wholesale_price', 'choose'];
  errorText: string = '';
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.key.length < 2) {
      this.dataSource = undefined
      return
    }
    this.productService.getByName(this.key).subscribe(
      (data) => {
        if (data === null) {
          this.dataSource = undefined
          return
        }
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        this.errorText = "ดึงข้อมูลไม่สำเร็จ";
      })
  }

  addToBasket(barcode: string){
    this.barcode.emit(barcode);
  }
}
